import { render, staticRenderFns } from "./hosting-dns-illustration.vue?vue&type=template&id=c18cb9fe"
import script from "./hosting-dns-illustration.vue?vue&type=script&lang=js"
export * from "./hosting-dns-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports